import { render, staticRenderFns } from "./selectHospital.vue?vue&type=template&id=644c6b6b&scoped=true"
import script from "./selectHospital.vue?vue&type=script&lang=ts"
export * from "./selectHospital.vue?vue&type=script&lang=ts"
import style0 from "./selectHospital.vue?vue&type=style&index=0&id=644c6b6b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644c6b6b",
  null
  
)

export default component.exports